import { styled, Tooltip, tooltipClasses, TooltipProps } from '@mui/material';

interface ThemedTooltipProps extends TooltipProps {
    background?: string;
    isBlurredBg?: boolean;
}

const ThemedTooltip = styled(
    ({ className, children, background, isBlurredBg, ...props }: ThemedTooltipProps) => (
        <Tooltip {...props} classes={{ popper: className }}>
            {children}
        </Tooltip>
    ),
)(({ theme, background, isBlurredBg }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: background ? 'transparent' : theme.palette.backgrounds.bg3,
        ...(background && { background }),
        color: theme.palette.text.primary,
        boxShadow: theme.shadows[1],
        fontSize: 12,
        maxWidth: '360px',
        padding: '12px',
        border: `1px solid ${theme.palette.divider}`,
        backdropFilter: isBlurredBg ? 'blur(20px)' : '',
    },
}));

export default ThemedTooltip;
